import App from "@app/App";
import { useAppDispatch } from "@app/hooks";
import { AmplifyProvider } from "@aws-amplify/ui-react";
import { CognitoUserAmplify } from "@features/aws-user/types";
import { useCallback, useEffect, useState } from "react";
import { setUser } from "./slice";
import { riotApi } from './api';
import {CircularProgress} from "@mui/material";

type Props = {
  user: CognitoUserAmplify;
};

const AuthProvider = ({ user }: Props) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);

  const onLoad = useCallback(async () => {
    try {
      setIsLoading(true);

      // First reset any existing API state
      dispatch(riotApi.util.resetApiState());

      const session = await user.getSignInUserSession();
      const token = session?.getIdToken().getJwtToken();

      if (!token) {
        throw new Error('No valid token found');
      }

      // Set new user state
      dispatch(setUser({
        username: user.username || '',
        attributes: user.attributes || null,
        idToken: token,
      }));

    } catch (error) {
      console.error('Error initializing auth state:', error);
      // You might want to handle this error appropriately
      // e.g., redirect to login or show error message
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, user]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  if (isLoading) {
    return <CircularProgress size="small" />;
  }

  return (
    <AmplifyProvider>
      <App />
    </AmplifyProvider>
  );
};

export default AuthProvider;
